define([
    'text!WebCommon/component/page-footer-new.html',
    'WebCommon/mixin/page-ready',
    'WebCommon/modal/modal',
    'jquery',

    'css!web/static/fonts/fangzheng.css',
    'css!WebCommon/component/page-footer-new.css'
], function(
    tpl,
    PageReadyMixin,
    Modal,
    $
){
    var menuGroups = [
        {
            title: '关于我们',
            list: [
                {name: '梵几STORY', link: '/fnjibrand'},
                {name: '梵几实体店', link: '/shop'},
                {name: '媒体报道', link: '/fnjimedia'},
                {name: '招聘信息', link: '/job'}
            ]
        },
        {
            title: '购物指南',
            list: [
                {name: '购物流程', link: '/howshop'},
                {name: '会员制度', link: '/membership'}
            ]
        },
        {
            title: '关于配送',
            list: [
                {name: '家具配送', link: '/aboutdeliver?index=0'},
                {name: '家居配送', link: '/aboutdeliver?index=1'},
                {name: '一枚板配送', link: '/aboutdeliver?index=2'}
            ]
        },
        {
            title: '售后服务',
            list: [
                {name: '家具售后', link: '/aboutservice?index=0'},
                {name: '家居售后', link: '/aboutservice?index=1'}
            ]
        },
        {
            title: '商业合作',
            list: [
                {name: '项目批量采购', link: '/site/cooperate?type=1'},
                {name: '设计公司合作', link: '/site/cooperate?type=2'},
                {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                {name: '艺术品合作', link: '/site/cooperate?type=5'},
                {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
            ]
        }
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin],
        data: function(){
            return {
                menuGroups: [],
                footerNew: [
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'},
                    {name: '售后服务', link: '/aboutservice'},
                    {name: '联系我们', link: '/site/cooperate?type=1'}
                ],
                isPC: true,
                isZh: true
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<755){
                    _this.isPC = false;
                }
                if(_this.$i18n.locale=='en'){
                    _this.footerNew = _this.$i18n.messages.en.footerNew;
                    _this.isZh = false;
                }else {
                    _this.footerNew = _this.$i18n.messages.zh.footerNew;
                    _this.isZh = true;
                }
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinModal();
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/component/page-footer-new.js
// module id = 62
// module chunks = 0 1 2 3 4 5 6 7 8